import React from 'react';
import {
  Toaster,
  ToastBar,
  toast,
  resolveValue,
  type Toast,
} from 'react-hot-toast';
import styles from './AppToaster.module.scss';

const toastOptions = {
  duration: 4000,
  className: styles.toastBar,
  success: {
    className: `${styles.toastBar} ${styles.toastSuccess}`,
  },
  error: {
    className: `${styles.toastBar} ${styles.toastError}`,
  },
  loading: {
    className: `${styles.toastBar} ${styles.toastLoading}`,
  },
  blank: {
    className: styles.toastBar,
  },
  custom: {
    className: `${styles.toastBar} ${styles.toastCustomShell}`,
  },
} as const;

function dismissToastIfAllowed(t: Toast): void {
  if (t.type !== 'loading') {
    toast.dismiss(t.id);
  }
}

function AppToaster() {
  return (
    <Toaster position="top-center" toastOptions={toastOptions}>
      {(t) => (
        <ToastBar toast={t}>
          {({ icon }) => (
            <div
              className={
                t.type === 'loading'
                  ? styles.toastInner
                  : `${styles.toastInner} ${styles.toastDismissible}`
              }
              role={t.type === 'loading' ? 'status' : 'button'}
              tabIndex={t.type === 'loading' ? undefined : 0}
              aria-live={t.type === 'loading' ? 'polite' : undefined}
              title={t.type === 'loading' ? undefined : 'Click to dismiss'}
              onClick={() => dismissToastIfAllowed(t)}
              onKeyDown={(event) => {
                if (t.type === 'loading') return;
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  dismissToastIfAllowed(t);
                }
              }}
            >
              {icon}
              <span className={styles.toastMessage}>
                {resolveValue(t.message, t)}
              </span>
            </div>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}

export default AppToaster;
